import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Element } from '../../../../common/html/element'
import { Radio } from '../../../../common/html/radio'
import { PopupAction } from '../../../../common/popup/PopupAction'
import EventEmitter, {
  DISABLE_BLOCK_NAVIGATION,
  SHOW_POPUP_UPGRADE,
} from '../../../../helpers/EventEmitter'
import { selectCompanyInfo } from '../../header/companyInfo/store/slice'
import { jsonToString } from './helper'
import classes from './index.module.scss'
import {
  addDefault,
  selectCompanyTypeTemplate,
  selectDefaultTemplate,
  selectIsFiinGateTemplate,
  selectName,
  selectPanelById,
  selectPanelId,
} from './store/slice'

const Button = ({
  children,
  action,
  saveTemplate,
  isButtonSave,
  defaultTemplateProp,
  isNotHasPermission,
  isFiinGateTemplateProp,
  isOpenConfirm,
  setIsOpenConfirm,
}) => {
  const dispatch = useDispatch()

  const defaultTemplateStore = useSelector(selectDefaultTemplate)
  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const name = useSelector(selectName)
  const isFiinGateTemplateStore = useSelector(selectIsFiinGateTemplate)
  const companyInfo = useSelector(selectCompanyInfo)
  const companyTypeTemplate = useSelector(selectCompanyTypeTemplate)

  const companyType = companyTypeTemplate || companyInfo.companyType
  const defaultTemplate = defaultTemplateProp || defaultTemplateStore
  const isFiinGateTemplate = isFiinGateTemplateProp || isFiinGateTemplateStore

  const placeHolder = UseI18n('preferenceSetting.PLH_INPUT')

  const [isShowPopup, setIsShowPopup] = useState(false)
  const [isShowPopupSaveAs, setIsShowPopupSaveAs] = useState(false)
  const [isSaveAs, setIsSaveAs] = useState(false)
  const [valueInput, setValueInput] = useState('')

  useEffect(() => {
    if (isFiinGateTemplate) {
      setIsSaveAs(true)
    }
  }, [isFiinGateTemplate])

  useEffect(() => {
    if (isOpenConfirm) {
      setIsShowPopup(true)
    }
  }, [isOpenConfirm])

  const showPopupConfirm = () => {
    if (isButtonSave) {
      if (isNotHasPermission) {
        EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
      } else {
        showPopupSaveAs()
      }
    } else if (
      name.trim() === defaultTemplate.templateName &&
      jsonToString(
        panelId.map((id) => ({ ...panelById[id], id: undefined })),
      ) ===
        jsonToString(
          defaultTemplate.panelId.map((id) => ({
            ...defaultTemplate.panelById[id],
            id: undefined,
          })),
        )
    ) {
      action()
    } else {
      setIsShowPopup(true)
    }
  }

  const showPopupSaveAs = () => {
    setIsShowPopupSaveAs(true)
    setIsShowPopup(false)
    EventEmitter.dispatch(DISABLE_BLOCK_NAVIGATION, true)
  }

  const hidePopupSaveAs = () => {
    setIsShowPopupSaveAs(false)
    EventEmitter.dispatch(DISABLE_BLOCK_NAVIGATION, false)
    setIsOpenConfirm()
  }

  const changeInput = (e) => setValueInput(e.target.value)

  const submit = async () => {
    setIsShowPopupSaveAs(false)

    const panels = panelId.map((id) => panelById[id])

    const data = {
      templateName: valueInput.trim(),
      isFiinGateTemplate,
      panels,
      companyType,
    }

    if (!isSaveAs) {
      data.templateId = defaultTemplate.templateId
      data.templateName = defaultTemplateProp?.templateName || name.trim()
    }

    const result = await saveTemplate(data)

    if (result) {
      if (!isSaveAs) {
        dispatch(
          addDefault({
            panelsSelected: panels,
            templateName: data.templateName,
            templateId: data.templateId,
            companyType,
          }),
        )
      }
      action()
    }
  }

  const isDisableSubmit = isSaveAs
    ? !valueInput?.trim()
    : !defaultTemplateProp && !name?.trim()
  const isDisableSaveChange = isFiinGateTemplate

  return (
    <>
      <div onClick={showPopupConfirm}>{children}</div>
      <PopupAction
        isShow={isShowPopup}
        title="preferenceSetting.SAVE_CHANGE"
        handleClose={() => {
          setIsShowPopup(false)
          setIsOpenConfirm()
        }}
        btnCancel={{
          label: 'common.NO',
          event: action,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: showPopupSaveAs,
          isI18n: true,
        }}
      >
        <Translate value="preferenceSetting.SAVE_CHANGE_NOTE" />
      </PopupAction>
      <PopupAction
        isShow={isShowPopupSaveAs}
        title="preferenceSetting.SAVE_CHANGE"
        handleClose={hidePopupSaveAs}
        btnCancel={{
          label: 'preferenceSetting.CANCEL',
          event: hidePopupSaveAs,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'preferenceSetting.SAVE',
          event: submit,
          isI18n: true,
          disabled: isDisableSubmit,
        }}
      >
        <Element>
          <Element>
            <Radio
              title={
                <>
                  <Translate value="preferenceSetting.SAVE_CHANGE_TO" /> "
                  {defaultTemplate.templateName}"
                </>
              }
              isI18n={false}
              value={false}
              activeValue={isSaveAs}
              onChange={setIsSaveAs}
              titleStyle={{
                fontWeight: 600,
                color: isDisableSaveChange ? '#9C9C9C' : '#3A414B',
              }}
              disabled={isDisableSaveChange}
            />
          </Element>
          <Element style={{ marginTop: 14 }}>
            <Radio
              title="preferenceSetting.SAVE_AS"
              value={true}
              activeValue={isSaveAs}
              onChange={setIsSaveAs}
              titleStyle={{ fontWeight: 600, color: '#3A414B' }}
            />
            <Element className="mt1">
              <Element
                elementName="input"
                style={{ border: '1px solid #E0E0E0' }}
                className={classes.inputSaveAs}
                placeholder={placeHolder}
                value={valueInput}
                onChange={changeInput}
              />
            </Element>
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}

Button.propTypes = {
  action: PropTypes.func,
  isButtonSave: PropTypes.bool,
  defaultTemplateProp: PropTypes.object,
  isNotHasPermission: PropTypes.bool,
  isOpenConfirm: PropTypes.bool,
  setIsOpenConfirm: PropTypes.func,
}

Button.defaultProps = {
  action: () => {},
  isButtonSave: false,
  isNotHasPermission: false,
  isOpenConfirm: false,
  setIsOpenConfirm: () => {},
}

export default Button
